import { render, staticRenderFns } from "./CustomerSnRuleList.vue?vue&type=template&id=35b454c9&"
import script from "./CustomerSnRuleList.vue?vue&type=script&lang=js&"
export * from "./CustomerSnRuleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports